export default __webpack_public_path__ + "static/clinic-a27e3f619a09bf57a8cd9474a49615ed.webp";